<template>
<div class="home-container">
    <div class="address">
        <p>1100 Lexington Ave</p>
        <p>New York</p>
        <p>NY 10075</p>
        <p>U.S.A.</p>
    </div>
</div>
</template>

<style lang="scss" scoped>
.home-container {
    margin: 0;
    padding: 0;

    .address {
        margin-top: 10rem;

        p {
            color: black;
            font-family: 'Bebas Neue', cursive;
            font-size: 4rem;
            letter-spacing: 0.8rem;
            margin: 0 0 1rem 0;
        }
    }
}
</style>
